import React from "react";

import { Skeleton, Stack } from "@mui/material";
import { CircularProgress } from "@mui/material";


function TableLoader() {
  return (
    <Stack spacing={0.5}>
      <Skeleton variant="rounded" height={50} />
      <Skeleton variant="rounded" animation="wave" height={50} />
      <Skeleton variant="rounded" animation={false} height={50} />
      <Skeleton variant="rounded" height={50} />
      <Skeleton variant="rounded" animation="wave" height={50} />
      <Skeleton variant="rounded" animation={false} height={50} />
    </Stack>
  );
}

export default TableLoader;


export function TdLoader() {
  return (
    <div  style= {{ textAlign: "center", marginTop: 6, height: 42 }}>
      <CircularProgress
          size={34}
          sx={{
          color: "var(--dark-gray)",
          }}
        />
    </div>
  );
}